import React from 'react'
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';


const Footer = () => {
    return (
        <div className="footer">
            <p>For more Contents and Apps like this, Follow me on Social Media.<hr color="#1c2c47"/></p>
            <div className="footer-links">
                <div  className="instagram"><a href="//www.instagram.com/dare_to_hug/"><InstagramIcon /></a> </div>
                <div className="facebook"><a href="//www.facebook.com/djkumar143/"><FacebookIcon /></a> </div>
                <div className="linkedin"><a href="//www.linkedin.com/in/deep-jyoti-160a22144/"><LinkedInIcon /></a></div>
            </div>
        </div>
    )
}

export default Footer
